import { Route, type EntryPoint } from '@wellesley/openapi'
import { AppsRoutes, getRoute } from '../getRoute'
import { replaceRouteAliases } from '../platformRoutes'

type GetAppRouteProps = {
  id: string
  routes: Route[]
  username?: string
  groupname?: string
  entryPoint: EntryPoint
}

export const getEntryAppRoute = ({
  id,
  routes,
  username,
  groupname,
  entryPoint,
}: GetAppRouteProps) => {
  const entryPointPath = routes.find(
    (route) => route.entryPointFor === entryPoint,
  )?.path
  const rootPath = routes.find((route) => route.path === '$root')?.path
  const pathWithAlias = entryPointPath || rootPath

  const isSpecialPath = pathWithAlias && pathWithAlias.includes('$')
  const defaultPath = `/${id}`

  const pathWithParams = (
    isSpecialPath
      ? replaceRouteAliases(pathWithAlias) || defaultPath
      : pathWithAlias || defaultPath
  ) as AppsRoutes

  return getRoute(
    pathWithParams,
    {
      username,
      groupname,
    },
    {
      skipParams: true,
    },
  )
}
